// extracted by mini-css-extract-plugin
export default {"paypalButton":"style_paypalButton__iV5CW","icon":"style_icon__qIvVR","text":"style_text__N1Myd"};